import { useEffect, useState } from "react";
import { Reply, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";

export function InboundReplyCard() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const load = () => api.get("/admin/email/inbound").then(({ data }) => setD(data)).catch(() => setD({}));
  useEffect(() => { load(); }, []);
  const enable = async () => {
    setBusy(true); setErr("");
    try { await api.post("/admin/email/inbound/enable"); await load(); }
    catch (e) { setErr(e.response?.data?.detail || "Could not enable"); }
    finally { setBusy(false); }
  };
  if (!d) return null;
  return (
    <div className="mt-4 rounded-xl border border-[#27272A] bg-[#121212] p-6" data-testid="inbound-reply-card">
      <div className="flex items-center gap-2">
        <Reply className="h-4 w-4 text-[#34C759]" />
        <h2 className="font-black text-xl tracking-tight">Reply-by-email for enquiries</h2>
        <span data-testid="inbound-reply-badge" className={`text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-full border ${d.enabled ? "text-[#34C759] border-[#34C759]/40 bg-[#34C759]/10" : "text-[#FF9F0A] border-[#FF9F0A]/40 bg-[#FF9F0A]/10"}`}>{d.enabled ? "on" : "off"}</span>
      </div>
      <p className="mt-2 text-sm text-neutral-400">Sellers and buyers answer an enquiry alert by simply hitting Reply in their inbox. The answer lands in the VISMARKS thread — neither side sees the other's address.</p>
      <div className="mt-3 text-xs font-mono text-neutral-500">Reply address pattern: <span className="text-neutral-300" data-testid="inbound-reply-example">{d.example}</span></div>
      <div className="mt-3 flex flex-wrap items-center gap-3">
        <button onClick={enable} disabled={busy} data-testid="inbound-reply-enable-btn" className="h-9 px-4 rounded-full bg-[#34C759] hover:bg-[#2fb350] text-black text-sm font-bold disabled:opacity-50">
          {busy ? "Connecting…" : d.enabled ? "Re-connect webhook" : "Enable email replies"}
        </button>
        {d.enabled && <span className="inline-flex items-center gap-1.5 text-xs text-[#34C759]" data-testid="inbound-reply-endpoint"><CheckCircle2 className="h-3.5 w-3.5" /> Resend → {d.endpoint}</span>}
        {err && <span className="text-xs text-[#FF3B30]" data-testid="inbound-reply-error">{err}</span>}
      </div>
    </div>
  );
}
